import { mdiTranslate } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Button } from '@/components/ui/button'
import { DrawerBody, DrawerFooter } from '@/components/ui/drawer'
import { HStack, Stack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import useCustomMediaQuery from '@/hooks/useCustomMediaQuery'
import { mobileUploadDrawerAtom, toggleUploadMobileDrawer } from '@/store/gigiChat/ChatAtom'

import ActionButtons from '../../conversationList/components/actionButtons'
import DropZone from '../leftSide/components/dropzone/'
import MultiSelect from '../leftSide/components/multiSelect'
import SectionDescription from '../leftSide/components/sectionDescription'
import UploadedFiles from '../leftSide/components/uploadedFiles'
import UploadingTranslateDocuments from '../leftSide/components/uploadingTranslationDocuments'

const MobileUploadDrawer = () => {
    const { t } = useTranslation()
    const [isOpen] = useAtom(mobileUploadDrawerAtom)
    const [isMobile] = useCustomMediaQuery()
    const onClose = () => {
        toggleUploadMobileDrawer()
    }
    const borderColor = useColorModeValue('gray.300', 'gray.700')
    return (
        <DrawerDialog isOpen={isMobile ? isOpen : false} onClose={onClose} size="lg" noPadding={true}>
            <DrawerBody p="0" px="24px" mb="16px">
                <HStack justifyContent="space-between" mt="8px">
                    <Text
                        fontSize="21px"
                        fontFamily="GSKPrecision-Bold"
                        fontWeight="bold"
                        letterSpacing="0.25px"
                        display="flex"
                        lineHeight="16px"
                    >
                        <Icon
                            path={mdiTranslate}
                            size="20px"
                            color="var(--chakra-colors-gray-800)"
                            style={{
                                marginRight: '18px',
                            }}
                        />
                        {t('chat.translate.leftSectionTitle')}
                    </Text>
                    <ActionButtons processingStrategy="Translation" />
                </HStack>
                <Stack height="100%">
                    <SectionDescription />
                    <MultiSelect />
                    <DropZone />
                    <UploadingTranslateDocuments />
                    <UploadedFiles />
                </Stack>
            </DrawerBody>
            <DrawerFooter borderTopWidth="1px" borderColor={borderColor} display="block" mx="24px" px="0" py="24px">
                <Button variant="secondary" mr="18px" onClick={onClose} textTransform="uppercase" letterSpacing="0.25px">
                    {t('documents.mobile.drawer.buttons.close')}
                </Button>
            </DrawerFooter>
        </DrawerDialog>
    )
}

export default MobileUploadDrawer
